import { handleAxiosError } from '../helpers'
import { instance } from '../helpers'

export const reminderServices = {
  post,
}

function post(params) {
  return instance
    .post('/reminders', params)
    .then(response => {
      return response
    })
    .catch(error => {
      return handleAxiosError(error)
    })
}
